module.exports = __webpack_public_path__ + "assets/img/15.9ac4e763.png";